import { render } from "./BuekReportIframe.vue?vue&type=template&id=7c5d91f2&ts=true"
import script from "./BuekReportIframe.ts?vue&type=script&lang=ts&external"
export * from "./BuekReportIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__